import { Routes } from "src/routes";
import { typeCheckAppModule } from "src/utils";
import { ArticleDetailPage } from "./ArticleDetailPage";

export const articleDetail = typeCheckAppModule({
    NAME: "articleDetail",
    Container: ArticleDetailPage,
    route: Routes.articleDetail,
});
